let googleMapsScriptLoadingPromise: Promise<void> | null = null;

export function loadGoogleMaps(apiKey: string): Promise<void> {
  if (typeof window !== "undefined" && window.google && window.google.maps) {
    return Promise.resolve();
  }

  if (!googleMapsScriptLoadingPromise) {
    googleMapsScriptLoadingPromise = new Promise<void>((resolve, reject) => {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
      script.async = true;
      script.onload = () => {
        if (window.google && window.google.maps) {
          resolve();
        } else {
          reject(
            new Error("Google Maps API loaded, but 'google.maps' is undefined.")
          );
        }
      };
      script.onerror = () =>
        reject(new Error("Failed to load Google Maps script."));
      document.head.appendChild(script);
    });
  }

  return googleMapsScriptLoadingPromise;
}
